export function isIdCard(rule, value, callback) {
  // return true;
  /**
       * 身份证15位编码规则：dddddd yymmdd xx p dddddd：6位地区编码 yymmdd: 出生年(两位年)月日，如：910215 xx:
       * 顺序编码，系统产生，无法确定 p: 性别，奇数为男，偶数为女
       *
       * 身份证18位编码规则：dddddd yyyymmdd xxx y dddddd：6位地区编码 yyyymmdd:
       * 出生年(四位年)月日，如：19910215 xxx：顺序编码，系统产生，无法确定，奇数为男，偶数为女 y: 校验码，该位数值可通过前17位计算获得
       *
       * 前17位号码加权因子为 Wi = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ] 验证位
       * Y = [ 1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2 ] 如果验证码恰好是10，为了保证身份证是十八位，那么第十八位将用X来代替
       * 校验位计算公式：Y_P = mod( ∑(Ai×Wi),11 ) i为身份证号码1...17 位; Y_P为校验码Y所在校验码数组位置
       */

  // 15位和18位身份证号码的正则表达式
  var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  // // 如果通过该验证，说明身份证格式正确，但准确性还需计算
  let flag = false;
  if (regIdCard.test(value)) {
    if (value.length == 18) {
      var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); // 将前17位加权因子保存在数组里
      var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
      for (var i = 0; i < 17; i++) {
        idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
      }
      var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
      var idCardLast = value.substring(17); // 得到最后一位身份证号码
      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod == 2) {
        if (idCardLast == 'X' || idCardLast == 'x') flag = true;
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (idCardLast == idCardY[idCardMod]) flag = true;
      }
    } else {
      return true;
    }
  }
  if (value && !flag) {
    callback(new Error('身份证格式不正确'));
  } else {
    callback();
  }
}
//验证小数数据
export function validateDecimal(rule, value, callback) {
  if (value === '' || value === null) {
    return callback(new Error('请输入有效的小数'));
  }
  if (!/^[-]?\d+(\.\d+)?$/.test(value)) { // 正则表达式检查是否为有效的小数（可以有0到多个小数点）
    return callback(new Error('请输入有效的小数'));
  }
  callback(); // 如果验证通过，调用callback()不传递参数或传递null/undefined/''等空值表示验证通过。
};

//验证j金额数据
export function validatePrice(rule, value, callback) {
  if (value === '' || value === null) {
    return callback(new Error('请输入有效的金额两位小数'));
  }
  if (!/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)) {
    return callback(new Error('请输入有效的金额两位小数'));
  }
  callback();
};

// 校验联系人至少有一组（配合表单中 prop="linkman" 的占位表单项使用）
// listGetter 可传联系人数组，或返回联系人数组的函数（通常是 () => this.form.links）
export function validateLinkmanList(listGetter) {
  return function (rule, value, callback) {
    const list = (typeof listGetter === 'function' ? listGetter() : listGetter) || [];
    if (!list.length) {
      return callback(new Error('请至少填写一组联系人'));
    }
    callback();
  };
};

// 判断手机号是否合法
export function validatePhone(rule, value, callback) {
  // if (value && !/^1[3|4|5|7|9|8][0-9]\d{8}$/.test(value)) {
  //     callback(new Error('请输入正确是手机号'));
  // } else {
  callback();
  // }
};
export function isValidJSON(text) {
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
};
export function isNumber(n) {
  typeof (n) === 'number' || n instanceof Number
}


// WEBPACK FOOTER //
// ./src/utils/validate.js